import { ContentEditorImageType } from './cms';
import { Animco, DiscountType, ObligationType, PriceType } from './product';

export interface FaiProduct extends FaiType {
    id: number;
    animco?: Animco;
    hat: string;
    title: string;
    subtitle: string;
    logo_offre?: string;
    image_alt: string;
    logo_alt?: string;
    techno: string;
    slug: string;
    range: string;
    range_ng: RangesNewGeneration;
    commercial_series: string;
    gencode_offre: string;
    image_url: string;
    nuggets: {
        logo_nuggets: string;
        texte: string;
        show_speed: boolean;
        position: string;
    }[];
    details_url: string;
    fai_options: {
        items: {
            name: string;
            label: string;
            logo_url: string;
            logo_alt: string;
            id: number;
            order: string;
            fai_roc_options_id: number;
            fai_roc_products_id: number;
        }[];
    };
    picto?: ContentEditorImageType;
    img_repeater?: ContentEditorImageType;
    pre_elig_speed_up: null | number;
    pre_elig_speed_down: null | number;
    pre_elig_speed_wording?: string;
    selector_title?: string;
    selector_subtitle?: string;
    gencode_repeater?: string;
    title_alert?: string;
    text_alert?: string;
    alerte_client_byou?: boolean;
    modal_title?: string;
    modal_subtitle?: string;
    modal_content_html?: string;
    modal_content?: string;
    modal_image?: ContentEditorImageType;

    // short_description, long_description, text_link, title_repeater : concernent le répéteur wifi associé à l'offre FAI
    short_description?: string;
    long_description?: string;
    text_link?: string;
    title_repeater?: string;
}

export enum RangesNewGeneration {
    VERY_FIT = 'very_fit',
    MUST = 'must',
    ULTYM = 'ultym',
}

export type FaiType = {
    categoryType?: string;
    commercialSeries: string;
    discounts: DiscountType[];
    neededElements?: { gencode: string; label: string }[];
    obligation?: ObligationType;
    play: Play;
    price: number;
    prices: PriceType;
    range: string;
    rangeNg: string;
    sku: string;
    speedDown?: string;
    speedUp?: string;
    technology?: TECHNOLOGY;
    type: string;
};

export type Play = '1P' | '2P' | '3P';

export enum TECHNOLOGY {
    FTTH = 'FTTH',
    ADSL = 'ADSL',
    VDSL = 'VDSL',
    BOX_4G = 'BOX_4G',
    BOX_5G = 'BOX_5G',
}
